(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atv-navigation"]) return;
  try {
    
if (!customElements.get('atv-navigation-shell')) {
  customElements.define('atv-navigation-shell', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.menu = this.querySelector('details');
      this.summary = this.querySelector('summary');
      const close = (focus = false) => {
        if (!this.menu.open) return;
        this.menu.open = false;
        if (focus) this.summary.focus();
      };
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.menu.open) { event.preventDefault(); close(true); }
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) close(); }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) close();
      }, options);
      this.addEventListener('click', event => { if (event.target.closest('a')) close(); }, options);
      this.desktop = matchMedia('(min-width:1100px)');
      this.desktop.addEventListener('change', event => { if (event.matches) close(); }, options);
      this.resize?.disconnect();
      this.resize = new ResizeObserver(entries => {
        const height = Math.ceil(entries[0].target.getBoundingClientRect().height);
        if (height > 0) document.documentElement.style.setProperty('--atv-kopf-hoehe', `${height}px`);
      });
      this.resize.observe(this.querySelector('.avn'));
      const signal = this.abort.signal;
      document.addEventListener('shopify:cart:lines-update', async event => {
        if (!event.promise) return;
        const sequence = this.cartSequence = (this.cartSequence || 0) + 1;
        try {
          const result = await event.promise;
          const count = result.cart?.totalQuantity;
          if (!this.isConnected || signal.aborted || sequence !== this.cartSequence || typeof count !== 'number') return;
          this.querySelector('[data-avn-count]').textContent = count;
          this.querySelector('.avn-cart').setAttribute('aria-label', `Warenkorb, ${count} Artikel`);
          this.querySelector('[data-avn-status]').textContent = `Warenkorb aktualisiert: ${count} Artikel`;
        } catch { /* The native cart component reports its own errors. */ }
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
